(() => {
  'use strict';
  if (window.miWishlistLoaded) return;
  const configNode = document.getElementById('mi-wishlist-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const key = `mi:wishlist:v1:${config.shop}`;
  const maxItems = 200;
  let items = [];
  let storageError = false;
  let liveTimer;
  let generation = 0;
  const controllers = new Set();
  const page = document.querySelector('[data-mi-wishlist-page]');
  const grid = page?.querySelector('[data-mi-wishlist-grid]');
  const summary = page?.querySelector('[data-mi-wishlist-summary]');
  const empty = page?.querySelector('[data-mi-wishlist-empty]');
  const live = document.createElement('div');
  live.className = 'mi-wishlist-live';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');
  live.setAttribute('aria-atomic', 'true');
  document.body.append(live);

  function normalize(value) {
    if (!value || value.version !== 1 || !Array.isArray(value.items)) return [];
    const unique = new Map();
    value.items.slice(0, maxItems).forEach(item => {
      if (!item || !/^\d{1,20}$/.test(String(item.id)) || typeof item.handle !== 'string' || !/^[a-z0-9][a-z0-9-]{0,199}$/.test(item.handle)) return;
      unique.set(String(item.id), {
        id: String(item.id), handle: item.handle,
        variant: /^\d{1,20}$/.test(String(item.variant)) ? String(item.variant) : '',
        added: Number.isFinite(item.added) ? item.added : 0
      });
    });
    return [...unique.values()];
  }
  function read() {
    try {
      const raw = localStorage.getItem(key);
      items = raw ? normalize(JSON.parse(raw)) : [];
      storageError = false;
    } catch (error) {
      if (error.name === 'SyntaxError') { items = []; storageError = false; }
      else storageError = true;
    }
    return items;
  }
  function announce(message) {
    clearTimeout(liveTimer);
    live.textContent = message;
    liveTimer = setTimeout(() => { live.textContent = ''; }, 6500);
  }
  function sync(root = document) {
    const savedIds = new Set(items.map(item => item.id));
    const toggles = [...root.querySelectorAll('[data-mi-wishlist-toggle]')];
    if (root.matches?.('[data-mi-wishlist-toggle]')) toggles.push(root);
    toggles.forEach(button => {
      const saved = savedIds.has(button.dataset.productId);
      if (button.hidden) button.hidden = false;
      const pressed = String(saved);
      const label = (saved ? config.remove : config.add).replace('__PRODUCT__', button.dataset.productTitle || button.dataset.productHandle);
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    });
    document.querySelectorAll('[data-mi-wishlist-count]').forEach(badge => {
      const count = items.length > 99 ? '99+' : String(items.length);
      const hidden = items.length === 0;
      const link = badge.closest('a');
      const label = `${config.title} (${items.length})`;
      if (badge.textContent !== count) badge.textContent = count;
      if (badge.hidden !== hidden) badge.hidden = hidden;
      if (link && link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
    });
  }
  function save(next) {
    try {
      localStorage.setItem(key, JSON.stringify({ version: 1, items: next }));
      items = next;
      storageError = false;
      sync();
      return true;
    } catch (_) {
      storageError = true;
      announce(config.storage_error);
      return false;
    }
  }
  function toggle(button) {
    read();
    if (storageError) { announce(config.storage_error); return; }
    const id = button.dataset.productId;
    const handle = button.dataset.productHandle;
    if (!/^\d{1,20}$/.test(id) || !/^[a-z0-9][a-z0-9-]{0,199}$/.test(handle)) return;
    const exists = items.some(item => item.id === id);
    if (!exists && items.length >= maxItems) { announce(config.limit); return; }
    const variant = (button.closest('[data-mi-tarjeta]') || button.closest('form'))?.querySelector('[data-mi-id]')?.value || '';
    const next = exists ? items.filter(item => item.id !== id) : [{ id, handle, variant, added: Date.now() }, ...items];
    if (!save(next)) return;
    announce(exists ? config.removed : config.saved);
    if (grid) {
      if (exists) {
        const article = [...grid.children].find(node => node.dataset.favoriteId === id);
        const nextFocus = article?.nextElementSibling?.querySelector('button, a') || article?.previousElementSibling?.querySelector('button, a');
        const heldFocus = article?.contains(document.activeElement);
        article?.remove();
        updateSummary();
        if (heldFocus) (nextFocus || page.querySelector('.mi-wishlist-back'))?.focus();
      } else render();
    }
  }
  function updateSummary() {
    if (!page) return;
    summary.textContent = storageError ? config.storage_error : config.count.replace('__COUNT__', String(items.length));
    empty.hidden = items.length !== 0 || storageError;
  }
  function recovery(slot, item, unavailable) {
    slot.className = 'mi-wishlist-recovery';
    slot.replaceChildren();
    const text = document.createElement('p');
    text.textContent = unavailable ? config.unavailable : config.load_error;
    slot.append(text);
    if (!unavailable) {
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.className = 'mi-wishlist-retry';
      retry.textContent = config.retry;
      retry.addEventListener('click', () => load(slot, item, generation), { once: true });
      slot.append(retry);
    }
    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'mi-wishlist-toggle';
    remove.dataset.miWishlistToggle = '';
    remove.dataset.productId = item.id;
    remove.dataset.productHandle = item.handle;
    remove.dataset.productTitle = item.handle.replaceAll('-', ' ');
    remove.textContent = config.remove.replace('__PRODUCT__', item.handle.replaceAll('-', ' '));
    slot.append(remove);
    sync(slot);
  }
  async function load(slot, item, version) {
    if (!slot.isConnected || version !== generation) return;
    slot.className = '';
    slot.textContent = config.loading;
    slot.setAttribute('aria-busy', 'true');
    const controller = new AbortController();
    controllers.add(controller);
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const url = new URL(`${config.root}products/${encodeURIComponent(item.handle)}`, location.origin);
      url.searchParams.set('view', 'mi-wishlist-card');
      if (item.variant) url.searchParams.set('variant', item.variant);
      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
      if (version !== generation || !slot.isConnected) return;
      if (response.status === 404 || response.status === 410) { recovery(slot, item, true); return; }
      if (!response.ok) throw new Error('load');
      const html = await response.text();
      if (version !== generation || !slot.isConnected) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const result = parsed.querySelector('[data-mi-wishlist-result]');
      const card = result?.querySelector('[data-mi-tarjeta]');
      if (!card || result.dataset.miWishlistResult !== item.id) throw new Error('result');
      card.querySelectorAll('script').forEach(node => node.remove());
      slot.replaceChildren(document.importNode(card, true));
      sync(slot);
    } catch (_) {
      if (version === generation && slot.isConnected) recovery(slot, item, false);
    } finally {
      clearTimeout(timer);
      controllers.delete(controller);
      slot.removeAttribute('aria-busy');
    }
  }
  async function render() {
    if (!grid) return;
    const version = ++generation;
    controllers.forEach(controller => controller.abort());
    grid.replaceChildren();
    updateSummary();
    if (storageError) return;
    const queue = items.map(item => {
      const slot = document.createElement('article');
      slot.dataset.favoriteId = item.id;
      grid.append(slot);
      return { slot, item };
    });
    const worker = async () => {
      while (queue.length && version === generation) {
        const { slot, item } = queue.shift();
        await load(slot, item, version);
      }
    };
    await Promise.all(Array.from({ length: Math.min(4, queue.length) }, worker));
  }
  read();
  sync();
  render();
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-mi-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    toggle(button);
  });
  new MutationObserver(records => {
    // Las apps y los carruseles añaden nodos ajenos a favoritos continuamente.
    // Sólo sincronizar inserciones que realmente contienen sus controles.
    const selector = '[data-mi-wishlist-toggle], [data-mi-wishlist-count]';
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))) sync(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-mi-wishlist-toggle]').forEach(button => button.setAttribute('data-mi-tooltip-dismissed', ''));
  });
  ['pointerover', 'focusin'].forEach(type => document.addEventListener(type, event => {
    const button = event.target.closest?.('[data-mi-wishlist-toggle]');
    if (button && !button.contains(event.relatedTarget)) button.removeAttribute('data-mi-tooltip-dismissed');
  }));
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    read(); sync(); render();
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    read(); sync(); render();
  });
  window.miWishlistLoaded = true;
})();
